import { Component, OnInit, Input, OnDestroy, Output, EventEmitter } from '@angular/core';
import { CustomerIn } from "src/classes/Customers/CustCard_1";
import { HttpServiceCustomer } from "src/app/services/Customer/http/http.service_Customer";
import { CustCard_1 } from "src/classes/Customers/CustCard_1";
import { CustCard_3 } from 'src/classes/Customers/CustCard_3';
import { Config } from 'src/classes/Common/ConfigData';
import { CustCardTabService } from 'src/app/services/Custcard/cust-card-tab/cust-card-tab.service';
import { HttpService1 } from "src/app/services/Automation/http/http.service_smsAppointment";
import { ControlsService } from 'src/app/services/Common/controls.service';
import { Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';

@Component({
    selector: 'app-custcardview1',
    templateUrl: './custcardview1.component.html',
    styleUrls: ['./custcardview1.component.css'],
    providers: [HttpServiceCustomer, HttpService1]
})
export class Custcardview1Component implements OnInit, OnDestroy {
    @Input() customerId: number = 0;
    @Input() custcard_3: CustCard_3 = new CustCard_3();
    @Output() openSmsDialog: EventEmitter<void> = new EventEmitter<void>();

    custcard_1: CustCard_1 = new CustCard_1();
    customerin: CustomerIn = new CustomerIn();
    config: Config = new Config();
    customClassificationData: { id: number, name: string }[] = [];

    constructor(private httpServiceCustomer: HttpServiceCustomer,
        public custCardTabService: CustCardTabService,
        private controlsService: ControlsService,
        private router: Router,
        private logger: NGXLogger) { }

    ngOnInit() {
        this.customerin.customer_id = this.customerId;

        // get Config data
        this.httpServiceCustomer.getConfig()
            .subscribe((data: Config) => {
                this.config = data;
            }, error => {
                console.log(error);
                this.logger.error("user: " + sessionStorage.getItem("email") + ", component: " + this.constructor.name + ", error: " + error.message);
            });

        //get custcard_1 data
        this.httpServiceCustomer.getCustCard_1(this.customerin)
            .subscribe((res: CustCard_1) => {
                this.custcard_1 = res;
                console.log("customerId from custcard_1:", this.custcard_1.customerId);
                console.log("custcard_1:", this.custcard_1);

                if (this.custcard_1.autoClassificationName !== '') {
                    this.customClassificationData.push({ id: 3, name: this.custcard_1.autoClassificationName });
                }
                if (this.custcard_1.debt && this.custcard_1.debt == 2) {
                    this.customClassificationData.push({ id: 2, name: "לקוח עם חוב" });
                }
                if (this.custcard_1.birthDay && this.custcard_1.birthDay == 1) {
                    this.customClassificationData.push({ id: 1, name: "יום הולדת החודש" });
                }

                console.log("customClassificationData: ", this.customClassificationData);
            }, error => {
                console.log(error);
                this.logger.error("user: " + sessionStorage.getItem("email") + ", component: " + this.constructor.name + ", error: " + error.message);
            });
    }

    ngOnDestroy(): void {
        this.custCardTabService.notificationTabIndex = 2;
    }

    backToClients(): void {
        this.router.navigate(["clients"]);
    }

    getClientImageSrc(custcard_3: CustCard_3): string {
        if (this.config) {
            return !custcard_3.imagePath ? "assets/img/client-avatar.png" : "https://optimusb12023.s3.eu-north-1.amazonaws.com/" + this.config.remotebusid + "/clients/" + custcard_3.customerId + "/" + custcard_3.imagePath;
        }
    }

    clearImagePath(id: number): void {
        if (this.custcard_3.customerId == id) {
            this.custcard_3.imagePath = "";
        }
    }

    notificationButtonClick(index: number): void {
        this.custCardTabService.notificationTabIndex = index;
    }

    isVIPCustomer(): boolean {
        if (this.custcard_3.idOfCategery && this.custcard_3.idOfCategery.split(";").includes("7")) {
            return true;
        }
    }

    getWhatsAppLink(): string {
        if (this.custcard_3 && this.custcard_3.pelephone && this.custcard_3.pelephone.length == 10) {
            return "https://wa.me/+972" + this.custcard_3.pelephone.slice(1);
        }
    }

    openDialog(): void {
        this.openSmsDialog.emit();
    }

    // Check if the control with the given id is disabled for the user by his role
    isDisabled(id: number): boolean {
        if (this.controlsService.custcardviewControlsData) {
            let control = this.controlsService.custcardviewControlsData.find(control => control.cb_id == id);
            if (!control) {
                return false;
            }
            let enabledRole = control.cb_is_enabled_role;
            let userRole = sessionStorage.getItem("userRole");
            return +userRole < +enabledRole;
        }
    }
}
